import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointRlt1Props {
  children: React.ReactNode;
}
const FeaturePointRlt1 = ({
  children
}: FeaturePointRlt1Props) => {
  return <div className="flex items-start" data-id="element-6037">
      <div className="flex-shrink-0 mt-1" data-id="element-6038">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-6039" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-6040">{children}</div>
    </div>;
};
export default FeaturePointRlt1;